import React, { useState } from 'react';
import { CountdownTimer } from '../components/CountdownTimer';
const comparisonTable = [{
  sit: 'Una decisión operativa llega al dueño',
  sin: 'La resolvés vos siempre',
  con: 'El equipo la resuelve con la Matriz de Decisión'
}, {
  sit: 'Te vas una semana de viaje',
  sin: 'La empresa se paraliza o llaman 20 veces',
  con: 'El sistema funciona con el Dashboard de 2 minutos'
}, {
  sit: 'Un cliente importante llama',
  sin: 'Solo acepta hablar con vos',
  con: 'El Guardián Comercial lo gestiona'
}, {
  sit: 'Querés tomar un viernes libre',
  sin: 'Imposible, todo depende de vos',
  con: 'Protocolo del Viernes Off instalado'
}, {
  sit: 'La empresa necesita crecer',
  sin: 'Tu tiempo no alcanza',
  con: 'Procesos Líquidos absorben más demanda sin más horas tuyas'
}];
const offRoadFeatures = ['Auditoría de Dependencia completa', 'Los 5 Guardianes que protegen tu tiempo', 'Sistema de Reporte por Excepción', 'Dashboard Off-Road CEO', 'Protocolo de Salida Gradual de 6 meses', 'Manual In Case of Fire', 'Ingeniería de Escalabilidad', 'La Mente del CEO de Tablero'];
export function PricingSection() {
  const [showOptions, setShowOptions] = useState(false);
  return <section id="pricing" className="py-16 md:py-24" style={{
    backgroundColor: '#1F1A17'
  }} data-id="element-77">
      <div className="max-w-6xl mx-auto px-4" data-id="element-78">
        {/* Urgency */}
        <div className="max-w-2xl mx-auto text-center mb-12 md:mb-16" data-id="element-79">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-500/10 text-red-500 font-bold text-sm mb-8 border border-red-500/20" data-id="element-80">
            <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-81" />
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </div>

          <CountdownTimer data-id="element-82" />

          <p className="text-lg md:text-xl text-gray-300 mt-8 mb-6" data-id="element-83">
            ⚠️ Después sube $10.000 ARS. No vuelve.
          </p>

          <div className="max-w-md mx-auto bg-gray-900 border border-gray-800 rounded-xl p-4" data-id="element-84">
            <div className="text-sm font-bold text-red-500 flex items-center gap-2 mb-2" data-id="element-85">
              <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-86" />
              Cupos al precio de lanzamiento — Quedan pocos
            </div>
            <div className="w-full bg-gray-800 rounded-full h-3 overflow-hidden mb-1" data-id="element-87">
              <div className="bg-gradient-to-r from-red-600 to-red-500 h-3 rounded-full" style={{
              width: '72%'
            }} data-id="element-88" />
            </div>
            <div className="text-xs text-gray-500 text-right" data-id="element-89">
              72% ya tomados
            </div>
          </div>
        </div>

        <h2 className="text-3xl md:text-5xl font-bold text-white text-center mb-10 md:mb-16" data-id="element-90">
          ELEGÍ TU MEGA KIT
        </h2>

        {/* Pricing Cards */}
        {!showOptions ? <div className="flex justify-center mb-20 md:mb-24" data-id="element-91">
            <button onClick={() => setShowOptions(true)} className="animate-pulse-glow inline-flex items-center justify-center w-full sm:w-auto px-12 py-6 text-xl md:text-2xl font-bold text-gray-950 bg-emerald-500 hover:bg-emerald-400 rounded-2xl transition-all active:scale-95" data-id="element-92">
              → VER OPCIONES DE COMPRA
            </button>
          </div> : <div className="animate-fade-in-up grid md:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto mb-20 md:mb-24" data-id="element-93">
            {/* Card 1 */}
            <div className="bg-gray-900 border border-gray-800 rounded-2xl md:rounded-3xl p-6 md:p-8 flex flex-col" data-id="element-94">
              <div className="text-4xl mb-4" data-id="element-95">📘</div>
              <h3 className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-96">
                MEGA KIT: MAESTRÍA OPERATIVA 2026
              </h3>
              <p className="text-emerald-500 font-medium mb-5 text-sm md:text-base" data-id="element-97">
                6 Tomos + 6 Bonos
              </p>
              <div className="bg-gray-800/50 rounded-xl p-4 mb-6" data-id="element-98">
                <span className="text-gray-500 text-xs block mb-1" data-id="element-99">
                  Ideal para:
                </span>
                <span className="text-white font-medium text-sm" data-id="element-100">
                  Dueños de PyME que quieren ordenar la empresa y reducir la
                  dependencia operativa
                </span>
              </div>
              <div className="mb-6" data-id="element-101">
                <div className="text-gray-500 line-through text-lg" data-id="element-102">
                  $97.000
                </div>
                <div className="text-4xl md:text-5xl font-bold text-white" data-id="element-103">
                  $19990
                </div>
              </div>
              <a href="https://www.nexorecursos.com/cart/52429049331988:1" className="w-full py-4 rounded-xl bg-gray-800 hover:bg-gray-700 text-white font-bold text-base md:text-lg transition-colors mt-auto border border-gray-700 text-center block" data-id="element-104">
                → QUIERO MI MEGA KIT
              </a>
            </div>

            {/* Card 2 - Highlighted */}
            <div className="bg-gradient-to-b from-gray-800 to-gray-900 border-2 border-emerald-500 rounded-2xl md:rounded-3xl p-6 md:p-8 flex flex-col relative" style={{
          boxShadow: '0 0 60px -15px rgba(16,185,129,0.25)'
        }} data-id="element-105">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-emerald-500 text-gray-950 font-bold px-4 py-1 rounded-full text-xs uppercase tracking-wide" data-id="element-106">
                MÁS ELEGIDO
              </div>
              <div className="text-4xl mb-4" data-id="element-107">🏆</div>
              <h3 className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-108">
                MEGA KIT + OFF-ROAD CEO ⭐
              </h3>
              <p className="text-emerald-500 font-medium mb-5 text-sm md:text-base" data-id="element-109">
                6 Tomos + 6 Bonos + Protocolo de Desconexión Total
              </p>
              <div className="bg-emerald-500/10 border border-emerald-500/20 rounded-xl p-4 mb-6" data-id="element-110">
                <span className="text-emerald-500/80 text-xs block mb-1" data-id="element-111">
                  Ideal para:
                </span>
                <span className="text-white font-medium text-sm" data-id="element-112">
                  Dueños que quieren además liberarse del día a día y escalar
                  sin trabajar más horas
                </span>
              </div>
              <div className="mb-6" data-id="element-113">
                <div className="text-gray-500 line-through text-lg" data-id="element-114">
                  $130.000
                </div>
                <div className="text-4xl md:text-5xl font-bold text-white" data-id="element-115">
                  $27.990
                </div>
              </div>
              <a href="https://www.nexorecursos.com/cart/52429003817236:1" className="animate-pulse-glow w-full py-4 rounded-xl bg-emerald-500 hover:bg-emerald-400 text-gray-950 font-bold text-base md:text-lg transition-all active:scale-95 mt-auto text-center block" data-id="element-116">
                → QUIERO EL MEGA KIT + OFF-ROAD CEO
              </a>
            </div>
          </div>}

        {/* Off-Road CEO Comparison */}
        <div className="max-w-5xl mx-auto" data-id="element-117">
          <h3 className="text-2xl md:text-4xl font-bold text-white text-center mb-10 md:mb-12" data-id="element-118">
            🕊️ ¿QUÉ AGREGA EL PROTOCOLO OFF-ROAD CEO?
          </h3>

          <div className="bg-gray-900 border border-gray-800 rounded-2xl md:rounded-3xl overflow-hidden mb-10 md:mb-12" data-id="element-119">
            <div className="overflow-x-auto" data-id="element-120">
              <table className="w-full text-left min-w-[700px]" data-id="element-121">
                <thead data-id="element-122">
                  <tr className="bg-gray-800/60" data-id="element-123">
                    <th className="p-4 md:p-6 text-gray-300 font-semibold text-sm border-b border-gray-700 w-1/3" data-id="element-124">
                      Situación en tu empresa
                    </th>
                    <th className="p-4 md:p-6 text-red-400 font-semibold text-sm border-b border-gray-700 w-1/3" data-id="element-125">
                      ❌ Sin Off-Road CEO
                    </th>
                    <th className="p-4 md:p-6 text-emerald-500 font-semibold text-sm border-b border-gray-700 w-1/3" data-id="element-126">
                      ✅ Con Off-Road CEO
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-127">
                  {comparisonTable.map((row, i) => <tr key={i} className="border-b border-gray-800/50 hover:bg-gray-800/20 transition-colors" data-id="element-128">
                      <td className="p-4 md:p-6 text-white font-medium text-sm" data-id="element-129">
                        {row.sit}
                      </td>
                      <td className="p-4 md:p-6 text-gray-400 text-sm" data-id="element-130">
                        {row.sin}
                      </td>
                      <td className="p-4 md:p-6 text-emerald-400 font-medium text-sm" data-id="element-131">
                        {row.con}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>

          <div className="bg-gray-800/30 border border-gray-700 rounded-2xl md:rounded-3xl p-6 md:p-10" data-id="element-132">
            <h4 className="text-xl md:text-2xl font-bold text-white mb-6 md:mb-8 text-center" data-id="element-133">
              ✅ EL OFF-ROAD CEO INCLUYE:
            </h4>
            <div className="grid md:grid-cols-2 gap-3 md:gap-4" data-id="element-134">
              {offRoadFeatures.map((f, i) => <div key={i} className="flex items-start gap-3" data-id="element-135">
                  <span className="text-emerald-500 mt-0.5 shrink-0" data-id="element-136">✅</span>
                  <span className="text-gray-300 font-medium text-sm md:text-base" data-id="element-137">
                    {f}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}